import React,{useState, useEffect}from 'react';
import { useLocation } from 'react-router-dom';
import Blank from './blanks.jsx'
import RVMStatus from './RVMStatus.jsx';
import ProjectItemsChecklist from './ProjectItemsChecklist.jsx';
import DefectsReport from './DefectsReport.jsx';

function Checklist() {
  const location = useLocation();
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = getProjectDetails ? JSON.parse(getProjectDetails) : {};
  const projectName = selectedProjectDetail?.projectName;
  const projectNumber = selectedProjectDetail?.projectNumber;
  const urnlist = selectedProjectDetail?.URN_List || {};
  const [currentComponent, setCurrentComponent] = useState(<RVMStatus/>);
  const [activeComponent, setActiveComponent] = useState("rvw");

  let user_company = JSON.parse(localStorage.getItem("userCompany"));
  let nus_sts = (user_company === "NUS") ? 1 : 0;
  let p_access = selectedProjectDetail?.Proj_Access?.proj_access_level;
  let p_roles = selectedProjectDetail?.Proj_Access?.proj_role ? selectedProjectDetail.Proj_Access.proj_role.join(", ") : "";
  let proj_name = selectedProjectDetail?.projectName;

  let qs_params = `nususer=${nus_sts}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;

  useEffect(()=>{
    const getSearch = location.search;
    if(getSearch.includes('rvw')){
      setActiveComponent("rvw")
      setCurrentComponent(<RVMStatus/>)
    } else if(getSearch.includes('defectsRep')){
      setActiveComponent("defectsRep")
      //setCurrentComponent(<DefectsReport/>)
    } else if(getSearch.includes('projItems')){
      setActiveComponent("projItems")
      //setCurrentComponent(<ProjectItemsChecklist />)
    }

  },[location])

  

  const handleComponentChange = (component) => {
    setCurrentComponent(component);
  };


  //{userMenuVisible && (
 //   <>
   //   <a href="#" onClick={() => handleComponentChange(<Homeacc />)}>
  //      <FontAwesomeIcon icon={faHome} />
  //    </a>
  //    <a href="#"  onClick={() => handleComponentChange(<Dashboardacc/>)} >
   //     <FontAwesomeIcon icon={faTachometerAlt} />
  //    </a>
   //   <a href="#" onClick={() => handleComponentChange(<ChecklistAcc/>)}>
   //     <FontAwesomeIcon icon={faListAlt} />
    //  </a>
   // </>

   const defects_report = `https://acc.autodesk.com/build/issues/projects/${projectNumber}/issues?${qs_params}&menu=Project Reports_Defects Report`;
  const proj_item_checklist = `https://acc.autodesk.com/build/files/projects/${projectNumber}?folderUrn=${urnlist?.proj_item_checklist || ''}&viewModel=detail&moduleId=folders&${qs_params}&menu=Project Reports_Project Items Checklist`;
  
  return (
    <div className="wbshor">
      <div className="login-header-wrap">
        <div className="login-header">
          <div className="pagetitle">{projectName ? projectName : 'Project Name'}</div>
          <div className="button-wrapper">
            {/* <button className="btntopright" id="optionsBtn">
              <p>&lt;</p>
            </button> */}
            <div className="options-popup" id="optionsPopup">
              <button className="option-btn yellow">Filter <i>▼</i></button>
              <button className="option-btn">Export report <i>▼</i></button>
              <button className="option-btn">Hide Columns <i>▼</i></button>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="innerwrap">
            <div className="leftbar">

            <button className={`option-btn btn1 ${activeComponent === "rvw" ? 'active' : ''}`} onClick={() => { setActiveComponent("rvw"); handleComponentChange(<RVMStatus/>)}}><span>RVW Status</span></button>
			     {/* <button className={`option-btn btn1 ${activeComponent === "defectsRep" ? 'active' : ''}`} onClick={() => { setActiveComponent("defectsRep"); handleComponentChange(<DefectsReport />)}}><span>Defects Report</span></button> */}
			      {/* <button className={`option-btn btn1 ${activeComponent === "projItems" ? 'active' : ''}`} onClick={() => { setActiveComponent("projItems"); handleComponentChange(<ProjectItemsChecklist />)}}><span>Project Items Checklist</span></button> */}
            <button 
            className={`option-btn btn1 ${activeComponent === "defectsRep" ? 'active' : ''}`} 
            onClick={() => window.location.href = defects_report}
          >Defects Report</button>
            
            <button
              className={`option-btn btn1 ${activeComponent === 'projItems' ? 'active' : ''}`}
              onClick={() => window.location.href = proj_item_checklist}
            >
              Project Items Checklist
            </button>
            {/* <button
              className={`option-btn btn1 ${activeComponent === 'projItems' ? 'active' : ''}`}
              onClick={() => window.location.href = `https://acc.autodesk.com/build/files/projects/${projectNumber}?folderUrn=urn%3Aadsk.wipprod%3Afs.folder%3Aco.-HYyKP9URbSKUwL67JgPrA&viewModel=detail&moduleId=folders`}
            >
              Project Items Checklist
            </button> */}
            </div>
           
            {currentComponent}
          </div>
        </div>
      </div>
      
    </div>
  );
}

export default Checklist;
